'use client';

import { COLORS } from '@/constants';
import styled from 'styled-components';

export const ColorInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ColorSwatch = styled.input`
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid ${COLORS['neutral/300']};
  border-radius: 6px;
  cursor: pointer;
  background: transparent;
  flex-shrink: 0;
  overflow: hidden;

  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  &::-webkit-color-swatch {
    border: none;
    border-radius: 5px;
  }
  &::-moz-color-swatch {
    border: none;
    border-radius: 5px;
  }
`;

export const ColorTextInput = styled.input`
  width: 86px;
  font-size: 14px;
  font-family: 'Fira Code', 'Cascadia Code', monospace;
  padding: 6px 8px;
  border: 1px solid ${COLORS['neutral/300']};
  border-radius: 6px;
  background: ${COLORS['neutral/50']};
  color: ${COLORS['primary/900']};
  outline: none;

  &:focus {
    border-color: ${COLORS['primary/500']};
  }
`;
